const translations = {
    es: {
        errorserver: "Error en el servidor",
        errorlogin: "Usuario o contraseña incorrectos",
        confirmedsendemail: "Correo enviado",
    },
    en: {
        errorserver: "Server error",
        errorlogin: "User or password incorrect",
        confirmedsendemail: "Email sent",
    }
}
export default translations
